import React, { Component } from "react"
import QualitativeQuestion from "../Reports/QualitativeQuestion"

class MeasurementQualitatives extends Component {
  render() {
    return <QualitativeQuestion {...this.props} isMeasure />
  }
}

export default MeasurementQualitatives
